import React from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import { cn } from '~/utils/cn'

import './index.scss'

const OnboardingContainer = ({ children, ...rest }) => {
    return (
        <div className='onboarding-container' {...rest}>
            {children}
        </div>
    )
}

const OnboardingSetup = ({ children, ...rest }) => {
    return (
        <div className='onboarding-setup' {...rest}>
            {children}
        </div>
    )
}

const OnboardingHeader = ({ children, ...rest }) => {
    return (
        <div className='onboarding-header' {...rest}>
            {children}
        </div>
    )
}

const OnboardingTitle = ({ children, ...rest }) => {
    return (
        <h1 className='onboarding-header__title' {...rest}>
            {children}
        </h1>
    )
}
const OnboardingDescription = ({ children, ...rest }) => {
    return (
        <p className='onboarding-header__description' {...rest}>
            {children}
        </p>
    )
}

const OnboardingContent = ({ children, ...rest }) => {
    return (
        <div className='onboarding-content' {...rest}>
            {children}
        </div>
    )
}
const OnboardingSteps = ({ children, ...rest }) => {
    return (
        <div className='onboarding-steps' {...rest}>
            {children}
        </div>
    )
}

const OnboardingStep = ({ icon, title, isOpen, isComplete, children, ...rest }) => {
    return (
        <div className={cn('onboarding-step', isOpen && 'onboarding-step--open')} {...rest}>
            <div className='onboarding-step__title'>
                {isComplete ? <Icons icon={'tickCircleGreen'} /> : icon}
                <span className='onboarding-step__title-text'>{title}</span>
            </div>
            {isOpen && <div className='onboarding-step__content'>{children}</div>}
        </div>
    )
}

const OnboardingSplash = ({ children, ...rest }) => {
    return (
        <div className='onboarding-splash' {...rest}>
            {children}
        </div>
    )
}

const OnboardingFooter = ({ children, ...rest }) => {
    return (
        <div className='onboarding-footer' {...rest}>
            {children}
        </div>
    )
}

export {
    OnboardingContainer,
    OnboardingSetup,
    OnboardingHeader,
    OnboardingTitle,
    OnboardingDescription,
    OnboardingContent,
    OnboardingSteps,
    OnboardingStep,
    OnboardingSplash,
    OnboardingFooter
}
